import { computed, ref } from 'vue'

import type { Vote } from '@backmarket/http-api/src/api-specs-content/models/article-votes'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'
import { useTheToast } from '@backmarket/nuxt-module-toast/useTheToast'

import { usePageParamsFromRoute } from '~/scopes/cms/composables/usePageParamsFromRoute'

export function useVoteForArticle() {
  const { openErrorToast } = useTheToast()
  const logger = useLogger()
  const $httpFetch = useHttpFetch()
  const { pageName, pageType } = usePageParamsFromRoute()

  const userVote = ref<Vote>()

  const hasVoted = computed(() => !!userVote.value)

  async function postVoteForArticle(vote: Vote) {
    const previousValue = userVote.value
    userVote.value = vote
    try {
      await $httpFetch('/content/page/:pageType/:pageName/votes', {
        method: 'POST',
        pathParams: { pageType, pageName },
        body: { vote },
      })
    } catch (err) {
      userVote.value = previousValue
      openErrorToast()

      const error = err as Error
      logger.error('[ACQ] Error when posting a vote for an article', {
        error,
        owners: ['bot-squad-content-front'],
      })
    }
  }

  return { postVoteForArticle, userVote, hasVoted }
}
